import jwtDecode  from 'jwt-decode';
import moment from "moment";

export const useJWTInfo = (token: string) => {
	try {
		const data: any = jwtDecode(token);
		const isValid = data?.exp > moment().unix()
		return [isValid, data];
	} catch (e) {
		return [false, {}];
	}

}
